var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M443.2,579.6l39.8,2v53.5H317v-50.9l23-2c12.5-1.3,20.2-5.4,20.2-21.4V374.7c0-14.8-4.1-19.5-17.4-19.5l-24.4-1.3v-55.5 h124.8L443.2,579.6L443.2,579.6z M393.7,136.1c34.8,0,60.1,26.2,60.1,59.4c0,33.3-25.4,57.8-61,57.8c-36.4,0-60.1-24.6-60.1-57.8 C332.8,162.3,356.5,136.1,393.7,136.1z M400,800C179.4,800,0,620.6,0,400S179.4,0,400,0c220.5,0,400,179.4,400,400 S620.5,800,400,800z M400,75C220.8,75,75,220.8,75,400s145.8,325,325,325s325-145.8,325-325S579.2,75,400,75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9adc287021ac3573c1be3cacd13af134.svg";
export { ForwardRef as ReactComponent };